import { useEffect, useRef } from 'react';

function useOutsideClickHandler(handler: () => void) {
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const el = ref?.current;

            if (!el || el.contains((event?.target as Node) || null)) {
                return;
            }
            
            setTimeout(() => {
                handler();
            }, 100);
        }

        document.addEventListener('mouseup', handleClickOutside);

        return () => {
            document.removeEventListener('mouseup', handleClickOutside);
        }
    }), [ref, handler];

    return ref;
}

export default useOutsideClickHandler;